(function () {
  'use strict';

  function initTrust() {
    var el = document.querySelector('.as-ck-cart-trust--mobile');
    if (!el || typeof Swiper === 'undefined') return;

    var swiperEl = el.querySelector('.swiper');
    var speed = parseInt(el.dataset.speed, 10) || 3000;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: true,
      autoplay: prefersReducedMotion ? false : { delay: speed, disableOnInteraction: false },
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrust);
  } else {
    initTrust();
  }
})();
